module.exports = __webpack_public_path__ + "src/assets/textures/env/trash_bin/trash_bag_256_bake.png";